import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
  selector: '[appSecureUrl]',
  providers: [{ provide: NG_VALIDATORS, useExisting: SecureUrlDirective, multi: true }],
  standalone: false
})
export class SecureUrlDirective implements Validator {
  @Input('appSecureUrl') isActive = true;

  static validator(control: AbstractControl, isActive: boolean = true): ValidationErrors | null {
    return (typeof isActive === 'boolean' && !isActive) || !control.value || SecureUrlDirective.isSecureUrl(control.value) ? null : { appSecureUrl: true };
  }

  static isSecureUrl(value: string) {
    try {
      const url = new URL(String(value || '').trim());
      const hostname = url.hostname.toLowerCase();
      const isHttps = url.protocol === 'https:';
      const isLocalhostHttp = url.protocol === 'http:' && ['localhost', '127.0.0.1', '[::1]'].includes(hostname);

      return isHttps || isLocalhostHttp;
    } catch {
      return false;
    }
  }

  constructor() {}

  validate(control: AbstractControl) {
    return SecureUrlDirective.validator(control, this.isActive);
  }
}
